import React, { memo, useMemo } from 'react';
import { toInteger } from 'lodash';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { isIE11 } from 'common/util/mobile';
import { BUTTON, Button } from 'components/common/Button/Button';
import TextAction from './TextAction';
import styles from './DataSourceAddNew.scss';

const DataSourceAddNew = ({
    addNewDataSourceOpen,
    addNewValue,
    toggleAddNewDataSource,
    onChangeAddNewDataSource,
    addNewDataSourceValue,
    dataType,
}) => {
    const isIntegerType = dataType === 'INTEGER';
    const isRealType = dataType === 'REAL';
    const isNumberType = isIntegerType || isRealType;

    const inputProps = useMemo(() => {
        if (isIE11() || !isNumberType) {
            return {
                type: 'text',
            };
        }

        return {
            step: '1',
            pattern: /-?\d+/,
            type: 'number',
        };

    }, [dataType]);

    const onChange = event => {
        const { value } = event.target;

        if (isIntegerType && !isIE11()) {
            return onChangeAddNewDataSource({ target: { value: toInteger(value) } });
        }

        return onChangeAddNewDataSource(event);
    };

    const onKeyDown = event => {
        if (event.key === 'e' && isIntegerType) {
            event.preventDefault();
        }
    };

    return (
        <div data-cy="DataSourceAddNew">
            <Button
                bgcolor={BUTTON.BGCOLOR.BLUE}
                color={BUTTON.COLOR.WHITE}
                onClick={toggleAddNewDataSource}
                text={'Add New Item'}
                data-cy="DataSourceAddNew-New"
            />

            {addNewDataSourceOpen && (
                <div className={styles.FormAddNew}>
                    <div className={styles.FormAddNew__Input}>
                        <input
                            placeholder={'Enter new value'}
                            autoFocus={true}
                            value={addNewValue}
                            onChange={onChange}
                            onKeyDown={onKeyDown}
                            {...inputProps}
                            data-cy="DataSourceAddNew-Newvalue"
                        />
                    </div>

                    <div className={styles.FormAddNew__Button} data-cy="DataSourceAddNew-btnDiv">
                        <TextAction icon={<CheckIcon />} onClick={addNewDataSourceValue} text={'Save'} data-cy="DataSourceAddNew-Save"/>
                        <TextAction icon={<CloseIcon />} onClick={toggleAddNewDataSource} text={'Cancel'} data-cy="DataSourceAddNew-Cancel"/>
                    </div>
                </div>
            )}
        </div>
    );
};

export default memo(DataSourceAddNew);
